module.exports = __webpack_public_path__ + "img/yjy_home_qr_1.168349e6.png";